import { useState } from "react";
import { http, formatErr } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { ShieldOff } from "lucide-react";

const inp = "w-full px-3 py-2 rounded-md border text-sm";
const bs = { borderColor: "var(--border-silver)" };
const CHECKS = [
  ["videochiamata_documento", "Videochiamata con documento d'identità"],
  ["di_persona_documento", "Di persona con documento d'identità"],
  ["telefono_numero_registrato", "Chiamata al numero di telefono registrato"],
];

// Azzeramento MFA di un agente: identità verificata dall'admin + password e codice dell'admin.
export function MfaAdminReset({ agent, onDone }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ identity_check: "", identity_note: "", password: "", code: "" });
  const mfa = !!useAuth().user?.mfa_enabled;
  const ok = f.identity_check && f.identity_note.trim().length >= 10 && f.password && (!mfa || f.code);
  const submit = async () => {
    const body = { identity_check: f.identity_check, identity_note: f.identity_note.trim(), password: f.password,
      ...(f.code.includes("-") ? { recovery_code: f.code } : { code: f.code }) };
    try {
      await http.post(`/admin/users/${agent.id}/mfa-reset`, body);
      toast.success("Verifica in due passaggi azzerata: sessioni dell'agente chiuse. Potrà accedere con la password e riattivarla dal profilo.");
      setOpen(false); setF({ identity_check: "", identity_note: "", password: "", code: "" }); onDone?.();
    } catch (e) { toast.error(formatErr(e)); }
  };
  if (!open) return <button onClick={() => setOpen(true)} data-testid="mfa-admin-reset-open" className="px-3 py-2 rounded-md border text-xs flex items-center gap-1" style={bs}><ShieldOff className="w-3 h-3" /> Azzera verifica in due passaggi</button>;
  return (
    <div className="p-3 rounded-md border space-y-2 w-full" style={bs} data-testid="mfa-admin-reset-panel">
      <p className="text-xs text-neutral-600">Solo se l'agente ha perso telefono e codici di recupero. Prima verifica la sua identità: l'email da sola non basta.</p>
      <select value={f.identity_check} onChange={(e) => setF({ ...f, identity_check: e.target.value })} data-testid="mfa-admin-reset-check" className={inp} style={bs}>
        <option value="">Come hai verificato l'identità?</option>
        {CHECKS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <input value={f.identity_note} onChange={(e) => setF({ ...f, identity_note: e.target.value })} placeholder="Nota (es. data, documento visto, chi ha verificato)" data-testid="mfa-admin-reset-note" className={inp} style={bs} />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="La tua password" autoComplete="current-password" data-testid="mfa-admin-reset-password" className={inp} style={bs} />
        {mfa && <input value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.trim() })} placeholder="Il tuo codice a 6 cifre" autoComplete="one-time-code" data-testid="mfa-admin-reset-code" className={inp} style={bs} />}
      </div>
      <div className="flex gap-2">
        <button onClick={submit} disabled={!ok} data-testid="mfa-admin-reset-confirm" className="px-3 py-2 rounded-md text-white text-xs disabled:opacity-40" style={{ background: "#be123c" }}>Azzera e chiudi le sessioni</button>
        <button onClick={() => setOpen(false)} data-testid="mfa-admin-reset-cancel" className="px-3 py-2 rounded-md border text-xs" style={bs}>Annulla</button>
      </div>
    </div>
  );
}
